import React, { createContext, useRef } from 'react';

export const ComplexTextEditingContext = createContext(null);

const Provider = ({ children }) => {
  const TEXT_EDITOR_HISTORY = useRef(new Map());
  return (
    <ComplexTextEditingContext.Provider value={TEXT_EDITOR_HISTORY}>
      {children}
    </ComplexTextEditingContext.Provider>
  );
}

export default Provider;